import { render } from "./UserAppLayout.vue?vue&type=template&id=db71a930"
import script from "./UserAppLayout.vue?vue&type=script&lang=js"
export * from "./UserAppLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__